/* ============================================================
   skinmade Berater-Dashboard — Events-Tab
   Self-contained IIFE. Exponiert window.SMBeraterEvents.
   Abhaengigkeiten: Leaflet (window.L, optional). Kein Zugriff
   auf berater-dashboard.js-Interna.
   ============================================================ */
(function () {
  'use strict';

  // Sprachtexte (sm-i18n) ueber den Dashboard-Helfer assets/sm-dashboard-i18n.js;
  // ohne ihn steht der Schluessel da (Plan 2026-10-29-dashboard-i18n).
  var i18n = function (key, vars) { return window.smI18n ? window.smI18n(key, vars) : key; };
  // Titel und Beschreibung pflegt der Admin optional auch englisch
  // (title_en/description_en im events-worker); ohne Helfer gilt Deutsch.
  var inhalt = function (de, en) { return window.smInhalt ? window.smInhalt(de, en) : de; };
  function titel(ev) { return inhalt(ev.title, ev.title_en); }
  function beschreibung(ev) { return inhalt(ev.description, ev.description_en); }
  // Sichtbare Texte stehen als eigene Literale neben dem Markup
  //   ('<p>' + 'Text' + '</p>'):
  // ins Woerterbuch kommt nur der Text, nie ein Tag-Rest (Plan 2026-10-29-dashboard-i18n).
  // Texte werden erst beim Zeichnen gebildet, nie schon beim Laden der Datei.
  // Kein Warten auf smI18nBereit noetig: diese Datei zeichnet beim Laden nichts,
  // init() ruft erst berater-dashboard.js beim Oeffnen des Reiters Events.

  var MAP_CENTER = [51.16, 10.45];
  var MAP_ZOOM   = 6;
  var MARKER_COLOR = '#4E8A6F';

  // ---------- Helfer ----------
  function escapeHTML(v) {
    if (v === null || v === undefined) return '';
    return String(v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Parse ISO-ish ("YYYY-MM-DD" oder "YYYY-MM-DDTHH:MM") als lokales Datum.
  function parseEventDate(str) {
    if (!str) return null;
    var s = String(str);
    var m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
    if (!m) {
      var d0 = new Date(s);
      return isNaN(d0.getTime()) ? null : d0;
    }
    var y  = parseInt(m[1], 10);
    var mo = parseInt(m[2], 10) - 1;
    var day = parseInt(m[3], 10);
    var hasTime = m[4] !== undefined;
    var hh = hasTime ? parseInt(m[4], 10) : 0;
    var mm = hasTime ? parseInt(m[5], 10) : 0;
    var d = new Date(y, mo, day, hh, mm, 0, 0);
    d._smHasTime = hasTime;
    return d;
  }

  // Datum je Sprache ueber smFmt (assets/sm-dashboard-i18n.js, im Layout vor
  // diesem Skript; Plan 2026-10-29-dashboard-i18n). Auf Deutsch zeichengleich
  // mit dem bisherigen Intl.DateTimeFormat('de-DE', 2-digit/2-digit/numeric
  // [+ hour/minute 2-digit]) bzw. toLocaleDateString('de-DE'). Ohne den Helfer
  // wie bisher deutsch.
  var DATUM_DE = { day: '2-digit', month: '2-digit', year: 'numeric' };
  var DATUM_ZEIT_DE = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
  function fmtDatum(d) {
    return window.smFmt ? window.smFmt.datum(d) : new Intl.DateTimeFormat('de-DE', DATUM_DE).format(d);
  }
  function fmtDatumZeit(d) {
    return window.smFmt ? window.smFmt.datumZeit(d) : new Intl.DateTimeFormat('de-DE', DATUM_ZEIT_DE).format(d);
  }
  function fmtDatumStandard(d) {
    return window.smFmt ? window.smFmt.datumStandard(d) : d.toLocaleDateString('de-DE');
  }

  function formatDate(str) {
    var d = parseEventDate(str);
    if (!d) return escapeHTML(str || '');
    var hasTime = !!d._smHasTime || /[T ]\d{2}:\d{2}/.test(String(str));
    try {
      var out = hasTime ? fmtDatumZeit(d) : fmtDatum(d);
      return hasTime ? i18n('dashboard.events.datumUhr', { zeit: out }) : out;
    } catch (e) {
      return fmtDatumStandard(d);
    }
  }

  // Als Funktion und nicht als Festwert: die Texte werden erst beim Zeichnen
  // gebildet, nicht schon beim Laden der Datei (Plan 2026-10-29-dashboard-i18n).
  function typeLabels() {
    return {
      flohmarkt: i18n('dashboard.events.typ.flohmarkt'),
      messe: i18n('dashboard.events.typ.messe'),
      stadtfest: i18n('dashboard.events.typ.stadtfest'),
      'berater-session': i18n('dashboard.events.typ.beraterSession'),
      lifestyle: i18n('dashboard.events.typ.lifestyle'),
      sonstiges: i18n('dashboard.events.typ.sonstiges')
    };
  }
  function typeLabel(t) { return typeLabels()[t] || (t ? String(t) : i18n('dashboard.events.typ.sonstiges')); }

  // Ist das Event vergangen? (end_at || start_at < heute 00:00)
  function isPast(ev) {
    var ref = ev.end_at || ev.start_at;
    var d = parseEventDate(ref);
    if (!d) return false;
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return d.getTime() < today.getTime();
  }

  // Status → { label, cls }
  function statusBadge(ev) {
    var past = isPast(ev);
    var s = ev.status;
    if (s === 'rejected')  return { label: i18n('dashboard.events.status.abgelehnt'),   cls: 'is-rejected' };
    if (s === 'cancelled') return { label: i18n('dashboard.events.status.abgesagt'),    cls: 'is-cancelled' };
    if (past || s === 'archived') return { label: i18n('dashboard.events.status.vergangen'), cls: 'is-past' };
    if (s === 'pending')   return { label: i18n('dashboard.events.status.inPruefung'),  cls: 'is-pending' };
    if (s === 'public')    return { label: i18n('dashboard.events.status.freigegeben'), cls: 'is-public' };
    return { label: escapeHTML(s || '—'), cls: 'is-pending' };
  }

  // ---------- State ----------
  function makeState(opts) {
    return {
      base: (opts.base || '').replace(/\/+$/, ''),
      consultantId: String(opts.consultantId || ''),
      pane: opts.pane,
      map: null,
      markerLayer: null,
      events: [],
      // Filter-State (Parität zur Website-Event-Karte)
      filters: { query: '', dateRange: 'all', geo: null }, // geo: {lat, lon, radiusKm}
      els: {}
    };
  }

  // ---------- Filter-Logik (portiert aus sm-partner-map.js) ----------
  function haystack(ev) {
    return [ev.title, ev.title_en, ev.address, typeLabel(ev.event_type), ev.description, ev.description_en]
      .join(' ').toLowerCase();
  }

  function dateCutoff(range) {
    var now = new Date();
    var d;
    if (range === 'month') {
      d = new Date(now.getFullYear(), now.getMonth() + 1, 0); // letzter Tag akt. Monat
    } else if (range === 'next3') {
      d = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate()); // ~3 Monate
    } else {
      return null;
    }
    return d.toISOString().slice(0, 10);
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function distanceLabel(km) {
    if (km == null) return '';
    return km < 1 ? i18n('dashboard.events.entfernung.unterEins') : i18n('dashboard.events.entfernung.km', { km: Math.round(km) });
  }

  // Standard-Sortierung: kommende zuerst (Datum aufsteigend), Vergangene ans Ende.
  function byUpcoming(a, b) {
    var pa = isPast(a) ? 1 : 0;
    var pb = isPast(b) ? 1 : 0;
    if (pa !== pb) return pa - pb;
    var da = parseEventDate(a.start_at);
    var db = parseEventDate(b.start_at);
    var ta = da ? da.getTime() : 0;
    var tb = db ? db.getTime() : 0;
    return ta - tb;
  }

  // Wendet Textsuche + Datumsfilter + Umkreis an und sortiert. Setzt ev._distKm.
  function applyFilters(state) {
    var events = state.events.slice();
    var f = state.filters;

    // (a) Textsuche
    var q = f.query;
    if (q) {
      events = events.filter(function (ev) { return haystack(ev).indexOf(q) >= 0; });
    }

    // (b) Datumsfilter (nur wenn != all)
    if (f.dateRange !== 'all') {
      var cutoff = dateCutoff(f.dateRange);
      if (cutoff) {
        events = events.filter(function (ev) {
          return String(ev.start_at || '').slice(0, 10) <= cutoff;
        });
      }
    }

    // (c) Umkreis (Geo): Distanz berechnen, per Radius filtern, nach Distanz sortieren
    var geo = f.geo;
    if (geo) {
      events.forEach(function (ev) {
        var lat = (ev.lat !== null && ev.lat !== undefined) ? parseFloat(ev.lat) : NaN;
        var lon = (ev.lon !== null && ev.lon !== undefined) ? parseFloat(ev.lon) : NaN;
        ev._distKm = (!isNaN(lat) && !isNaN(lon)) ? haversineKm(geo.lat, geo.lon, lat, lon) : null;
      });
      events = events.filter(function (ev) { return ev._distKm != null && ev._distKm <= geo.radiusKm; });
      events.sort(function (a, b) { return a._distKm - b._distKm; });
    } else {
      events.forEach(function (ev) { ev._distKm = null; });
      events.sort(byUpcoming);
    }

    return events;
  }

  // Rendert Liste UND Karte auf Basis des gefilterten Sets.
  function render(state) {
    var events = applyFilters(state);
    renderList(state, events);
    renderMarkers(state, events);
  }

  // ---------- Karte ----------
  function initMap(state) {
    if (!window.L) return; // Leaflet nicht geladen → Karte ueberspringen
    var el = state.pane.querySelector('[data-sm-events-map]');
    if (!el) return;
    if (state.map) return;
    try {
      var map = window.L.map(el, {
        center: MAP_CENTER,
        zoom: MAP_ZOOM,
        scrollWheelZoom: false
      });
      window.L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_4au0_1_3fb44aa84a198235c03f67ef', {
        attribution: '&copy; OpenStreetMap &copy; CARTO',
        maxZoom: 19
      }).addTo(map);
      state.map = map;
      state.markerLayer = window.L.layerGroup().addTo(map);
    } catch (e) {
      state.map = null;
    }
  }

  function renderMarkers(state, events) {
    if (!state.map || !state.markerLayer || !window.L) return;
    events = events || state.events;
    state.markerLayer.clearLayers();
    var bounds = [];
    for (var i = 0; i < events.length; i++) {
      var ev = events[i];
      if (ev.lat === null || ev.lat === undefined || ev.lon === null || ev.lon === undefined) continue;
      var lat = parseFloat(ev.lat);
      var lon = parseFloat(ev.lon);
      if (isNaN(lat) || isNaN(lon)) continue;

      var badge = statusBadge(ev);
      var icon = window.L.divIcon({
        className: 'sm-events-marker-wrap',
        html: '<span class="sm-events-marker" style="background:' + MARKER_COLOR + '"></span>',
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        popupAnchor: [0, -10]
      });
      var popup =
        '<div class="sm-events-popup">' +
          '<strong>' + escapeHTML(titel(ev)) + '</strong><br>' +
          escapeHTML(formatDate(ev.start_at)) + '<br>' +
          escapeHTML(ev.address || '') +
          '<br><span class="sm-events-badge ' + badge.cls + '">' + escapeHTML(badge.label) + '</span>' +
        '</div>';
      var marker = window.L.marker([lat, lon], { icon: icon }).bindPopup(popup);
      marker.addTo(state.markerLayer);
      bounds.push([lat, lon]);
    }
    if (bounds.length) {
      try { state.map.fitBounds(bounds, { padding: [40, 40], maxZoom: 11 }); } catch (e) {}
    }
    // Groessen-Korrektur, falls Karte erst nach Tab-Wechsel sichtbar wird
    setTimeout(function () { try { state.map.invalidateSize(); } catch (e) {} }, 60);
  }

  // ---------- Liste ----------
  function renderList(state, events) {
    var listEl = state.pane.querySelector('[data-sm-events-list]');
    if (!listEl) return;
    events = events || state.events;

    if (!events.length) {
      // Unterscheide: gar keine Events angelegt vs. nur keine Filter-Treffer.
      var hasFilter = !!(state.filters.query || state.filters.dateRange !== 'all' || state.filters.geo);
      if (state.events.length && hasFilter) {
        var filterMsg = state.filters.geo
          ? i18n('dashboard.events.liste.keineImUmkreis')
          : i18n('dashboard.events.liste.keineZuFiltern');
        listEl.innerHTML =
          '<div class="sm-events__empty">' +
            '<div class="sm-events__empty-icon">🔍</div>' +
            '<p>' + escapeHTML(filterMsg) + '</p>' +
          '</div>';
      } else {
        listEl.innerHTML =
          '<div class="sm-events__empty">' +
            '<div class="sm-events__empty-icon">📍</div>' +
            '<p>' + i18n('dashboard.events.liste.leer') + '</p>' +
            '<p class="sm-events__empty-sub">' + i18n('dashboard.events.liste.leerHinweis') + '</p>' +
          '</div>';
      }
      return;
    }

    var html = '';
    for (var i = 0; i < events.length; i++) {
      var ev = events[i];
      var badge = statusBadge(ev);
      var isOwn = String(ev.consultant_id) === state.consultantId;
      var canCancel = isOwn && ev.status !== 'cancelled' && ev.status !== 'rejected';
      var distHtml = (ev._distKm != null)
        ? '<span class="sm-events-card__dist">📍 ' + escapeHTML(distanceLabel(ev._distKm)) + '</span>'
        : '';

      html +=
        '<article class="sm-events-card">' +
          '<div class="sm-events-card__top">' +
            '<h3 class="sm-events-card__title">' + escapeHTML(titel(ev)) + '</h3>' +
            '<span class="sm-events-badge ' + badge.cls + '">' + escapeHTML(badge.label) + '</span>' +
          '</div>' +
          '<div class="sm-events-card__meta">' +
            '<span class="sm-events-card__type">' + escapeHTML(typeLabel(ev.event_type)) + '</span>' +
            '<span class="sm-events-card__date">📅 ' + escapeHTML(formatDate(ev.start_at)) + '</span>' +
            distHtml +
          '</div>' +
          (ev.address ? '<p class="sm-events-card__addr">📍 ' + escapeHTML(ev.address) + '</p>' : '') +
          (beschreibung(ev) ? '<p class="sm-events-card__desc">' + escapeHTML(beschreibung(ev)) + '</p>' : '') +
          (canCancel
            ? '<div class="sm-events-card__actions">' +
                '<button type="button" class="sm-btn sm-btn-ghost sm-events-card__cancel" data-sm-events-cancel-id="' + escapeHTML(ev.id) + '">' + i18n('dashboard.events.absagen.knopf') + '</button>' +
              '</div>'
            : '') +
        '</article>';
    }
    listEl.innerHTML = html;

    // Absagen-Buttons verdrahten
    var cancelBtns = listEl.querySelectorAll('[data-sm-events-cancel-id]');
    for (var j = 0; j < cancelBtns.length; j++) {
      cancelBtns[j].addEventListener('click', function () {
        var id = this.getAttribute('data-sm-events-cancel-id');
        cancelEvent(state, id, this);
      });
    }
  }

  // ---------- Daten laden ----------
  function loadEvents(state) {
    var listEl = state.pane.querySelector('[data-sm-events-list]');
    var url = state.base + '/berater/events?consultantId=' + encodeURIComponent(state.consultantId);
    return fetch(url, {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (data) {
        state.events = (data && data.events) ? data.events : [];
        render(state);
      })
      .catch(function () {
        if (listEl) {
          listEl.innerHTML =
            '<div class="sm-events__empty">' +
              '<div class="sm-events__empty-icon">⚠️</div>' +
              '<p>' + i18n('dashboard.events.liste.ladenFehler') + '</p>' +
            '</div>';
        }
      });
  }

  // ---------- Absagen ----------
  function cancelEvent(state, id, btn) {
    if (!id) return;
    if (!window.confirm(i18n('dashboard.events.absagen.frage'))) return;
    if (btn) { btn.disabled = true; btn.textContent = i18n('dashboard.events.absagen.laeuft'); }
    fetch(state.base + '/berater/events/' + encodeURIComponent(id) + '/cancel', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ consultantId: state.consultantId })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cancel failed');
        return r.json().catch(function () { return {}; });
      })
      .then(function () { loadEvents(state); })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = i18n('dashboard.events.absagen.knopf'); }
        window.alert(i18n('dashboard.events.absagen.fehler'));
      });
  }

  // ---------- Formular ----------
  function setMsg(msgEl, text, isError) {
    if (!msgEl) return;
    if (!text) { msgEl.hidden = true; msgEl.textContent = ''; return; }
    msgEl.hidden = false;
    msgEl.textContent = text;
    msgEl.classList.toggle('is-error', !!isError);
    msgEl.classList.toggle('is-success', !isError);
  }

  function initForm(state) {
    var form   = state.pane.querySelector('[data-sm-events-form]');
    var newBtn = state.pane.querySelector('[data-sm-events-new]');
    var cancelBtn = state.pane.querySelector('[data-sm-events-cancel]');
    var msgEl  = state.pane.querySelector('[data-sm-events-form-msg]');
    if (!form || !newBtn) return;

    function openForm() { form.hidden = false; form.classList.remove('is-submitted'); setMsg(msgEl, ''); }
    function closeForm() { form.hidden = true; form.classList.remove('is-submitted'); setMsg(msgEl, ''); }
    function toggleForm() { if (form.hidden || form.classList.contains('is-submitted')) openForm(); else closeForm(); }

    newBtn.addEventListener('click', toggleForm);
    if (cancelBtn) cancelBtn.addEventListener('click', closeForm);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[data-sm-events-submit]');

      function val(name) {
        var el = form.elements[name];
        return el ? String(el.value || '').trim() : '';
      }

      var title = val('title');
      var address = val('address');
      var startDate = val('start_at');
      var startTime = val('start_time');
      var endDate = val('end_at');

      // Minimale Client-Validierung (Worker validiert autoritativ)
      if (!title) { setMsg(msgEl, i18n('dashboard.events.formular.titelFehlt'), true); return; }
      if (!address) { setMsg(msgEl, i18n('dashboard.events.formular.adresseFehlt'), true); return; }
      if (!startDate) { setMsg(msgEl, i18n('dashboard.events.formular.datumFehlt'), true); return; }

      var start_at = startTime ? (startDate + 'T' + startTime) : startDate;
      var end_at = endDate ? endDate : '';

      var payload = {
        consultantId: state.consultantId,
        title: title,
        event_type: val('event_type') || 'sonstiges',
        address: address,
        start_at: start_at,
        end_at: end_at,
        description: val('description'),
        image_url: val('image_url'),
        url: val('url')
      };

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = i18n('dashboard.events.formular.wirdEingereicht'); }
      setMsg(msgEl, '');

      fetch(state.base + '/berater/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            return { ok: r.ok, status: r.status, body: body };
          });
        })
        .then(function (res) {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = i18n('dashboard.events.formular.einreichen'); }
          if (res.ok) {
            // Formular-Felder leeren, Eingabebereich einklappen, Erfolgsmeldung
            // sichtbar lassen (die Meldung liegt im Form-Container, der offen bleibt).
            form.reset();
            form.classList.add('is-submitted');
            setMsg(msgEl, i18n('dashboard.events.formular.eingereicht'), false);
            loadEvents(state);
          } else {
            var err = (res.body && res.body.error) ? res.body.error : i18n('dashboard.events.formular.fehler');
            setMsg(msgEl, err, true);
          }
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = i18n('dashboard.events.formular.einreichen'); }
          setMsg(msgEl, i18n('dashboard.events.formular.netzwerk'), true);
        });
    });
  }

  // ---------- Filterleiste: Umkreis (Geolocation ODER PLZ/Ort) ----------
  function currentRadiusKm(state) {
    return (state.els.radius && Number(state.els.radius.value)) || 50;
  }

  function geoStatus(state, msg, isError) {
    var el = state.els.geoStatus;
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
  }

  function setGeoActive(state, active) {
    var els = state.els;
    if (els.geoBtn) {
      els.geoBtn.classList.remove('is-loading');
      els.geoBtn.classList.toggle('is-active', active);
      els.geoBtn.textContent = active ? '📍 ' + i18n('dashboard.events.umkreis.aktiv') : '📍 ' + i18n('dashboard.events.umkreis.inDerNaehe');
    }
    if (els.geoClear) els.geoClear.hidden = !active;
  }

  function setGeoCenter(state, lat, lon, label) {
    state.filters.geo = { lat: lat, lon: lon, radiusKm: currentRadiusKm(state) };
    setGeoActive(state, true);
    geoStatus(state, i18n('dashboard.events.umkreis.um', { ort: label }), false);
    render(state);
  }

  function requestGeo(state) {
    var els = state.els;
    if (!navigator.geolocation) {
      geoStatus(state, i18n('dashboard.events.umkreis.keinStandort'), true);
      if (els.geoInput) els.geoInput.focus();
      return;
    }
    if (els.geoBtn) { els.geoBtn.classList.add('is-loading'); els.geoBtn.textContent = i18n('dashboard.events.umkreis.ermittelt'); }
    navigator.geolocation.getCurrentPosition(function (pos) {
      if (els.geoBtn) els.geoBtn.classList.remove('is-loading');
      setGeoCenter(state, pos.coords.latitude, pos.coords.longitude, i18n('dashboard.events.umkreis.deinStandort'));
    }, function () {
      // Freigabe verweigert / nicht verfügbar → PLZ-Fallback anbieten
      if (els.geoBtn) { els.geoBtn.classList.remove('is-loading'); els.geoBtn.textContent = '📍 ' + i18n('dashboard.events.umkreis.inDerNaehe'); }
      geoStatus(state, i18n('dashboard.events.umkreis.freigabeNicht'), true);
      if (els.geoInput) els.geoInput.focus();
    }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
  }

  // PLZ/Ort → lat/lon via Nominatim (clientseitig, CORS-fähig). Kein OS-Standort nötig.
  function geocodeAndSet(state, query) {
    var q = (query || '').trim();
    if (!q) return;
    geoStatus(state, i18n('dashboard.events.umkreis.suche', { suche: q }), false);
    var url = 'https://nominatim.openstreetmap.org/search?format=json&countrycodes=de&limit=1&q=' + encodeURIComponent(q);
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
      .then(function (data) {
        if (!Array.isArray(data) || !data.length) {
          geoStatus(state, i18n('dashboard.events.umkreis.keinOrt', { suche: q }), true);
          return;
        }
        var hit = data[0];
        var label = (hit.display_name || q).split(',').slice(0, 2).join(', ');
        setGeoCenter(state, Number(hit.lat), Number(hit.lon), label);
      })
      .catch(function () { geoStatus(state, i18n('dashboard.events.umkreis.sucheFehler'), true); });
  }

  function clearGeo(state) {
    state.filters.geo = null;
    setGeoActive(state, false);
    geoStatus(state, '', false);
    if (state.els.geoInput) state.els.geoInput.value = '';
    render(state);
  }

  // Verdrahtet die Filterleiste EINMALIG (in der Init-Phase, nicht beim Daten-Reload).
  function initFilters(state) {
    var pane = state.pane;
    var els = {
      search:    pane.querySelector('[data-sm-bev-search]'),
      geoBtn:    pane.querySelector('[data-sm-bev-geo]'),
      geoClear:  pane.querySelector('[data-sm-bev-geo-clear]'),
      geoInput:  pane.querySelector('[data-sm-bev-geo-input]'),
      geoStatus: pane.querySelector('[data-sm-bev-geo-status]'),
      radius:    pane.querySelector('[data-sm-bev-radius]'),
      dateChips: pane.querySelectorAll('[data-sm-bev-datefilter] [data-bev-date]')
    };
    state.els = els;

    // Textsuche
    if (els.search) {
      els.search.addEventListener('input', function (e) {
        state.filters.query = String(e.target.value || '').trim().toLowerCase();
        render(state);
      });
    }

    // Datumsfilter-Chips
    Array.prototype.forEach.call(els.dateChips, function (chip) {
      chip.addEventListener('click', function () {
        state.filters.dateRange = chip.getAttribute('data-bev-date') || 'all';
        Array.prototype.forEach.call(els.dateChips, function (c) {
          c.classList.toggle('is-active', c === chip);
        });
        render(state);
      });
    });

    // Umkreis "In meiner Nähe"
    if (els.geoBtn) els.geoBtn.addEventListener('click', function () { requestGeo(state); });
    if (els.geoClear) els.geoClear.addEventListener('click', function () { clearGeo(state); });
    if (els.radius) {
      els.radius.addEventListener('change', function () {
        if (state.filters.geo) {
          state.filters.geo.radiusKm = Number(els.radius.value) || 50;
          render(state);
        }
      });
    }
    // PLZ/Ort-Eingabe (Fallback ohne OS-Standortfreigabe) → geocoden
    if (els.geoInput) {
      els.geoInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); geocodeAndSet(state, els.geoInput.value); }
      });
    }
  }

  // ---------- Public API ----------
  window.SMBeraterEvents = {
    init: function (opts) {
      if (!opts || !opts.pane || !opts.base || !opts.consultantId) return;
      var pane = opts.pane;
      if (pane._smEventsInited) {
        // Idempotent: nur Daten neu laden, falls schon initialisiert
        return;
      }
      pane._smEventsInited = true;

      var state = makeState(opts);
      initForm(state);
      initFilters(state);
      initMap(state);
      loadEvents(state);
    }
  };
})();
